import { Injectable, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { PlayerLaunch } from '../main/player/player.component';

@Injectable()
export class ModalsService {
  public toggleLoadingScreenEvent = new EventEmitter<boolean>();
  public openModalEvent = new EventEmitter<WarningInfo>();
  public closeModalEvent = new EventEmitter<DialogAction>();
  public togglePlayerEvent = new EventEmitter<PlayerLaunch>();

  constructor() {
  }

  // ---- Player ----
  openPlayer(id: string) {
    this.togglePlayerEvent.emit({
      isOpened: true,
      recordingId: id
    });
  }
  // ---- Loading screen ----
  openLoadingScreen() {
    this.toggleLoadingScreenEvent.emit(true);
  }

  closeLoadingScreen() {
    this.toggleLoadingScreenEvent.emit(false);
  }

  // ---- Warning ----
  openWarning(reason: string, guidense: string, actionType: ConfirmableActions): Promise<boolean> {
    const info: WarningInfo = {
      state: true,
      reason,
      guidense,
      actionType
    };

    this.openModalEvent.emit(info);
    return new Promise((resolve, reject) => {
      const sbscr = this.closeModalEvent.subscribe((resp: DialogAction) => {
        if (resp.action === actionType && resp.isConfirmed) {
          resolve(true);
          this.closeWarning(actionType);
        } else if (resp.action === actionType && !resp.isConfirmed) {
          resolve(false);
          this.closeWarning(actionType);
        }
      });
    });
  }

  closeWarning(action: ConfirmableActions) {
    const info: WarningInfo = {
      state: false,
      reason: 'closed',
      guidense: 'closed',
      actionType: action
    };

    this.openModalEvent.emit(info);
  }
}

export interface WarningInfo {
  state: boolean;
  reason: string;
  guidense: string;
  actionType: ConfirmableActions;
}

export interface DialogAction {
  isConfirmed: boolean;
  action: ConfirmableActions;
}

export enum ConfirmableActions {
  None = 'none',
  Logout = 'logout',
  Delete = 'delete',
  DeleteSelected = 'deleteSelected',

}



// WEBPACK FOOTER //
// ./src/app/services/modals.service.ts